import React from "react";

export default function FormattedDate(props) {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const day = days[props.date.getDay()];
  const date = props.date.getDate();
  const month = months[props.date.getMonth()];

  let hours = props.date.getHours();
  if (hours < 10) hours = `0${hours}`;

  let minutes = props.date.getMinutes();
  if (minutes < 10) minutes = `0${minutes}`;

  return (
    <div>
      {day} {date} {month}, {hours}:{minutes}
    </div>
  );
}
